import React from "react";
import {Button} from "src/components/Button";
import Dialog from "src/components/Dialogs/Dialog";
import {ITranslatedComponent, ITypefamilyMap} from "src/redux/reducers/generalReducer";
import {translate} from "react-i18next";
import * as _ from "lodash";
import SelectField from "src/components/SelectField";
import { ResourceListOfModelyearDto} from "src/services/Client";
import {Table} from "semantic-ui-react";

interface IApprovalSelectionDialogProps extends ITranslatedComponent {
    countList: any;
    userPSLModelyears: ResourceListOfModelyearDto;
    userTypefamiliesMap: ITypefamilyMap;
    onSelectionDialogSubmit: (modelYearObjectId: string, typeFamilyObjectId: string) => void;
    onSelectionDialogClose: () => void;
}

interface IApprovalSelectionDialogState {
    /** Selected basic market PSL. */
    selectedModelYear: any;
    selectedTypeFamily: any;
    modelYears: any[];
    typefamilies: any[];

}
const modelYearsRenderer = (modelYear: any) => {
    return modelYear.count > 0 ? `${modelYear.mj4} (${modelYear.count})` : `${modelYear.mj4}`;
};
const typefamilyRenderer = (typefamily: any) => {
    return typefamily.count > 0 ? `${typefamily.name} (${typefamily.count})` : `${typefamily.name}`;
};
class ApprovalSelectionDialog extends React.Component<IApprovalSelectionDialogProps, IApprovalSelectionDialogState> {
    constructor(props: IApprovalSelectionDialogProps) {
        super(props);

        this.state = {
            selectedModelYear: undefined,
            selectedTypeFamily: undefined,
            modelYears: [],
            typefamilies: []
        };
        this.onModelYearChanged = this.onModelYearChanged.bind(this);
    }
    componentDidMount(): void {
        if (this.props.userPSLModelyears.elements) {
            const modelYears: any = [];
            this.props.userPSLModelyears.elements.forEach((modelYear: any) => {
                const getCountRecord = this.props.countList.approvalCountByModelYearList.find((count: any) => count.objectId === modelYear.objectId);
                if (getCountRecord) {
                    modelYears.push({
                        ...modelYear,
                        count: getCountRecord.count,
                    });
                }
            });
            this.setState({modelYears});
        }

    }
    onModelYearChanged(selectedValue?: any) {
        if (this.props.userTypefamiliesMap && selectedValue) {
            const typefamilies: any = [];
            const getTypeFamilies = this.props.userTypefamiliesMap[selectedValue.mj1].elements;
            if (getTypeFamilies) {
                getTypeFamilies.forEach((typefamily: any) => {
                    const getCountRecord = this.props.countList.approvalCountByTypeFamilyList.find((count: any) => count.objectId === typefamily.objectId);
                    if (getCountRecord) {
                        typefamilies.push({
                            ...typefamily,
                            count: getCountRecord.count,
                        });
                    }
                });
                this.setState({typefamilies, selectedModelYear: selectedValue});
            }
        }
    }

    render() {
        const style = {width: '100%'};
        const headerStyle: React.CSSProperties = {textAlign: 'left', fontWeight: 'normal', width:'10%'};
        const {t,onSelectionDialogSubmit,onSelectionDialogClose} = this.props;
        return (
            <Dialog
                open={true}
                title=""
                actions={[
                    <Button
                        key={"submitButton"}
                        disabled={!this.state.selectedModelYear || !this.state.selectedTypeFamily}
                        icon={"checkmark"}
                        onClick={() => onSelectionDialogSubmit(this.state.selectedModelYear.objectId, this.state.selectedTypeFamily.objectId)}
                    />,
                    <Button
                        key={"cancelButton"}
                        icon={"ban"}
                        onClick={() => onSelectionDialogClose()}
                    />
                ]}
            >
                <Table>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell negative={(!this.state.selectedModelYear || !this.state.selectedTypeFamily)}>
                                <table style={style}>
                                    <tbody>
                                        <thead><tr><th colSpan={1} style={headerStyle}>{t("SELECT_CONTEXT")}:</th></tr></thead>
                                        <tr>
                                            <td style={{width: '50%'}}>
                                                <SelectField
                                                    placeholder={t("MODELYEAR")}
                                                    dataSource={this.state.modelYears}
                                                    rendererKey={modelYearsRenderer}
                                                    onChange={this.onModelYearChanged}
                                                />
                                            </td>
                                        </tr>
                                        <tr style={{marginTop: '10px'}}>
                                            <td style={{width: '50%'}}>
                                                <SelectField
                                                    placeholder={t("TYPEFAMILY")}
                                                    dataSource={this.state.typefamilies}
                                                    rendererKey={typefamilyRenderer}
                                                    onChange={(selectedValue) => this.setState({selectedTypeFamily: selectedValue})}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>

            </Dialog>
        );
    }
}

export default translate("OPTIONS_VIEW")(ApprovalSelectionDialog);



// WEBPACK FOOTER //
// ./src/views/ApprovalView/ApprovalSelectionDialog.tsx